








































































































import Vue from 'vue'

export default Vue.extend({
  data: (): any => ({
    errorMessages: '',
    nickname: '',
    email: '',
    password: '',
    passwordConfirm: '',
    passwordShow: false,
    passwordConfirmShow: false,
    formHasErrors: false,
    rules: {
      required: (v: string) => !!v || '해당 칸을 입력해주세요.',
      nickname: (v: string) => (v.length >= 2 && v.length <= 10) || '닉네임은 2~10자로 설정해주세요.',
      email: (v: string) => /.+@.+/.test(v) || '이메일 형식에 맞게 작성해주세요.',
      password: (v: string) => /^.*(?=^.{8,15}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*+=]).*$/.test(v) || '비밀번호는 문자/숫자/특수문자를 포함한 8~15자리로 입력해주세요.',
    },
  }),

  computed: {
    form (): Record<string, any> {
      return {
        nickname: this.nickname,
        email: this.email,
        password: this.password,
        passwordConfirm: this.passwordConfirm,
      };
    },
    passwordConfirmRule () {
      return this.password === this.passwordConfirm || '비밀번호를 다시 확인해주세요.';
    }
  },

  watch: {
    name (): void {
      this.errorMessages = '';
    },
  },

  methods: {
    resetForm (): void {
      this.errorMessages = '';
      this.formHasErrors = false;
      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset();
      });
    },
    submit (): void {
      // validation
      this.formHasErrors = false;
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;
        if (!this.$refs[f].validate(true)) this.formHasErrors = true;
      });
      if (!this.formHasErrors) {
        // axios post
        const user = {
          email: this.email,
          nickname: this.nickname,
          password: this.password,
        };
        // console.log('signup methods');
        // console.log(user);
        this.$store.dispatch('userModule/signup', user).then(() => {
          alert('회원가입이 완료되었습니다.');
          // 폼 초기화
          this.errorMessages = '';
          this.nickname = '';
          this.email = '';
          this.password = '';
          this.passwordConfirm = '';
          this.goToLogin();
        })
      }
    },
    goToLogin (): void {
      this.$emit('goToLogin');
    },
    close (): void {
      this.$emit('close');
    }
  },
})
